import React, { FC, useContext } from "react";
import {
  BASE_URL,
  // BASE_URL_CMS,
  GET_USER_INFO,
} from "utilFunctions/Constants/urlConstants";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import {
  ToastContextDispatch,
  UserInfoContextDispatch,
} from "Context/CommonContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { mapToArrayForSelect } from "utilFunctions/helperFunctions/HelperFunction";
import jwt_decode from "jwt-decode";
import { GoogleLogin } from "@react-oauth/google";
import {
  encrypt1,
  handleJWTToken,
} from "utilFunctions/helperFunctions/loginHelper";
import axios from "axios";
import {
  sendLoginEventToGTAG,
  pushToDataLayerForGTM,
} from "utilFunctions/helperFunctions/analytics";

export type LoginFormFields = {
  password: string;
  email: string;
};

export const emailPattern = {
  value: new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$", "ig"),
  message: "Enter a valid email address.",
};
export type useAPIType = {
  makeRequest: () => void;
  loading: boolean;
  responseData: any;
  error: any;
};

// const ref = React.createRef<HTMLInputElement>();
export const LoginForm: FC = () => {
  const userinfoDispatch = useContext<any>(UserInfoContextDispatch);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { login, logout } = useAuth();
  // const {
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<LoginFormFields>();
  // const {
  //   makeRequest: postLoginData,
  //   loading: loadingLogin,
  //   responseData: loginData,
  //   error: loginError,
  // } = usePutPostAPI(
  //   (data: any) => {
  //     localStorage.setItem("token", data["id_token"]);
  //     localStorage.setItem("refreshToken", data["refresh_token"]);
  //     getuserInfo(data.id_token);
  //   },
  //   (error) => {
  //     onFetchError(error);
  //   },
  //   "POST"
  // );

  // const getuserInfo = async (token: any) => {
  //   const url = BASE_URL + GET_USER_INFO;
  //   if (token) {
  //     await getAPIRequest({
  //       url: url,
  //       success: (response: any) => {
  //         login({
  //           token: token,
  //           refreshToken: token,
  //         });
  //         const data = response?.data?.data;
  //         localStorage.setItem(
  //           "idToStreamName",
  //           JSON.stringify(data?.idToStreamName)
  //         );
  //         const objforMapToSelect = {
  //           suggest: data,
  //           keyToSet: "idToStreamName",
  //           order: true,
  //         };
  //         const streamsArray = mapToArrayForSelect(objforMapToSelect);
  //         const newstreamsArray = streamsArray.filter(
  //           (item) =>
  //             item.label == "SOF" || item.label == "SOM" || item.label == "SOE"
  //         );
  //         userinfoDispatch({
  //           ...data,
  //           id: data?.id,
  //           facId: data?.id,
  //           user_name: data?.name,
  //           username: data?.username,
  //           email: data?.email,
  //           branch: data?.branch,
  //           department: data?.department,
  //           role: data?.role,
  //           class_id: data?.class_id,
  //           branchId: data?.branchId,
  //           branchName: data?.branchName,
  //           idToStreamName: data?.idToStreamName,
  //           employeeId: data?.employeeId,
  //           subjects: data?.subjects,
  //           userStreams:
  //             newstreamsArray && Array.isArray(newstreamsArray)
  //               ? newstreamsArray
  //               : [],
  //         } as IUserInfo);
  //         ToastDispatch({
  //           isOpen: true,
  //           type: "Success",
  //           message: "Logged in",
  //         });
  //       },
  //       failure: (err: any) => {
  //         logout();
  //         localStorage.removeItem("token");
  //         localStorage.removeItem("refreshToken");
  //         ToastDispatch({
  //           isOpen: true,
  //           type: "Error",
  //           message: err?.message,
  //         });
  //       },
  //     } as getRequestInterface);
  //   }
  // };
  // const onSubmit = handleSubmit((data) => {
  //   const Obj = {
  //     username: data.email,
  //     password: data.password,
  //     userTheme: "CMS_THEME_NAME",
  //   };
  //   postLoginData(ssoUrl + LOG_IN, Obj);
  // });

  // const onFetchError = (error: any) => {
  //   ToastDispatch({
  //     isOpen: true,
  //     type: "Error",
  //     message: error["response"]["data"]["message"],
  //   });
  // };

  const handleCallbackgoogle = (response: any) => {
    const token = handleJWTToken(response.credential);
    const decodeToken = jwt_decode(token) as any;
    sendLoginEventToGTAG("login", decodeToken?.email, "");
    encrypt1(token).then((resolve) => {
      console.log("encrypt3", resolve);
      getUserInfoAfterSSO(resolve);
    });
  };

  // const validateUserlogin = async (encryptedToken: any, token: any) => {
  //   axios
  //     .get(BASE_URL_CMS + "validateLogin", {
  //       headers: {
  //         Authorization: encryptedToken, //the token is a variable which holds the token
  //       },
  //     })
  //     .then(
  //       (data: any) => {
  //         console.log(data);
  //         userlogin(BASE_URL_CMS + "login", encryptedToken, token);
  //       },
  //       (error: any) => {
  //         ToastDispatch({
  //           isOpen: true,
  //           type: "Error",
  //           message: error.message,
  //         });
  //       }
  //     )
  //     .catch((err: any) => {
  //       ToastDispatch({ isOpen: true, type: "Error", message: err.message });
  //     });
  // };
  // const userlogin = (url: any, encryptedtoken: any, token: any) => {
  //   axios
  //     .get(url, {
  //       headers: {
  //         Authorization: encryptedtoken, //the token is a variable which holds the token
  //       },
  //     })
  //     .then((data) => {
  //       console.log(data);
  //       getUserInfoAfterSSO(encryptedtoken);
  //       if (token == undefined && token == null) {
  //         localStorage.setItem("token", encryptedtoken);
  //         localStorage.setItem("refreshToken", encryptedtoken);
  //       }
  //     });
  // };

  const getUserInfoAfterSSO = (token: any) => {
    axios
      .get(BASE_URL + GET_USER_INFO, {
        headers: {
          Authorization: token, //the token is a variable which holds the token
        },
      })
      .then((response) => {
        if (response?.data && response.data != null) {
          if (token != undefined && token != null) {
            login({
              token: token,
              refreshToken: token,
            });
            localStorage.setItem("token", token);
            localStorage.setItem("refreshToken", token);
          }
          const data = response?.data?.data;

          const objforMapToSelect = {
            suggest: data,
            keyToSet: "idToStreamName",
            order: true,
          };
          const newSubjectArray = data?.subjects.map((ele: any) => {
            return { label: ele.subjectName, key: ele.id, value: ele.id };
          });
          const streamsArray = mapToArrayForSelect(objforMapToSelect);
          const newstreamsArray: any = streamsArray.filter(
            (item) =>
              item.label == "SOF" || item.label == "SOM" || item.label == "SOE"
          );
          localStorage.setItem(
            "idToStreamName",
            JSON.stringify(newstreamsArray)
          );

          sendLoginEventToGTAG("login", data?.email, data?.fexRole);
          pushToDataLayerForGTM({ event: "login", user_role: data?.fexRole });
          userinfoDispatch({
            ...data,
            id: data?.id,
            facId: data?.id,
            user_name: data?.name,
            username: data?.username,
            email: data?.email,
            branch: data?.branch,
            department: data?.department,
            role: data?.role,
            class_id: data?.class_id,
            branchId: data?.branchId,
            branchName: data?.branchName,
            idToStreamName: data?.idToStreamName,
            employeeId: data?.employeeId,
            subjects: data?.subjects,
            subjectsListing: newSubjectArray,
            syllabusCompliance: true,
            userStreams:
              newstreamsArray && Array.isArray(newstreamsArray)
                ? newstreamsArray
                : [],
            fexRole: data?.fexRole,
            region: data?.region,
          } as IUserInfo);
          ToastDispatch({
            isOpen: true,
            type: "Success",
            message: "Logged in",
          });
          window.location.reload();
        }
      })
      .catch((err) => {
        logout();
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.response?.data?.message || err?.message,
        });
      });
  };

  // const userName: any = {
  //   style: {
  //     flexDirection: "column",
  //   },
  // };

  return (
    <div>
      {/* <form onSubmit={onSubmit} className="mx-auto">
        <FormInput<LoginFormFields>
          ref={ref}
          id="email"
          type="email"
          name="email"
          label="Email Address"
          placeholder="Email Address"
          className="mb-2 d-flex mw-100 flex-column"
          register={register}
          rules={{
            required: "You must enter your email address.",
            pattern: emailPattern,
          }}
          errors={errors}
          {...userName}
        />
        <FormInput<LoginFormFields>
          ref={ref}
          id="password"
          type="password"
          name="password"
          label="Password"
          placeholder="password"
          className="mb-2 d-flex mw-100 flex-column mt-4"
          register={register}
          rules={{
            required: "You must enter your Password.",
            minLength: {
              value: 6,
              message: "Password must have at least 6 characters",
            },
          }}
          errors={errors}
          {...userName}
        />
        <Button
          type="submit"
          color="aeslPrimary"
          className="mt-5 w-100 text-white"
        >
          Login
        </Button>
      </form> */}
      <div className="w-100 mt-2">
        <GoogleLogin
          size="large"
          width="auto"
          shape="circle"
          onSuccess={(credentialResponse: any) => {
            handleCallbackgoogle(credentialResponse);
          }}
          onError={() => {
            ToastDispatch({
              isOpen: true,
              type: "Error",
              message: "Login Failed",
            });
          }}
        />
      </div>
    </div>
  );
};
